import React from "react"

const AnchorTag = (props) => (
    <a {...props}>{props.text}</a>
)

export default AnchorTag;